export const faqSections = [
  {
    id: 'general',
    title: 'General',
    items: [
      {
        question: 'What is Follow Hub?',
        answer: 'Follow Hub gives businesses one public page to organize links, services, and updates for customers.',
      },
      {
        question: 'How long does it take to set up a profile?',
        answer: 'Most businesses can publish a profile in minutes and continue updating details over time.',
      },
      {
        question: 'Is Follow Hub free to use?',
        answer: 'Yes. Businesses can join for free and create a public profile. Optional verification requests are handled separately.',
      },
      {
        question: 'Can I update my profile after it goes live?',
        answer: 'Yes. You can edit links, contact details, and messaging whenever your business changes.',
      },
      {
        question: 'Where should I share my profile link?',
        answer: 'Use your profile link on social media, email signatures, QR cards, and campaign materials.',
      },
    ],
  },
  {
    id: 'business',
    title: 'Business',
    items: [
      {
        question: 'How do I join as a business?',
        answer: 'Use Sign up free on the landing page and choose the business flow to create your account.',
      },
      {
        question: 'How do I sign in to my business account?',
        answer: 'Use the Log in button on the landing page and enter your business email and password.',
      },
      {
        question: 'What do the badges mean?',
        answer: 'Badges communicate trust signals. Some represent profile authenticity and others represent verified impact-related commitments.',
      },
      {
        question: 'Can I still access business tools?',
        answer: 'Yes. Business tools and management pages remain available in the current business experience.',
      },
    ],
  },
  {
    id: 'customer',
    title: 'Customer',
    items: [
      {
        question: 'How do customers use Follow Hub?',
        answer: 'Customers browse business profiles to find links, contact options, and trusted information before deciding where to spend.',
      },
      {
        question: 'Do customers need an account to browse profiles?',
        answer: 'No account is required for basic discovery. Accounts are only needed for customer-specific features.',
      },
      {
        question: 'How do customers sign in or join?',
        answer: 'Customers can use the same Sign up and Log in entry points, then select the customer flow when prompted.',
      },
    ],
  },
];
